import { render, staticRenderFns } from "./CopyEmbedModal.vue?vue&type=template&id=7999fda4&scoped=true"
import script from "./CopyEmbedModal.vue?vue&type=script&lang=js"
export * from "./CopyEmbedModal.vue?vue&type=script&lang=js"
import style0 from "./CopyEmbedModal.vue?vue&type=style&index=0&id=7999fda4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7999fda4",
  null
  
)

export default component.exports